<template>
  <layout>
    <!-- <img
      v-if="brokerLogoUrl"
      class="h-11 w-auto mx-auto md:hidden my-6"
      :src="brokerLogoUrl"
      alt="broker logo"
    /> -->
    <h1 class="header-text text-center">Connection Complete!</h1>
    <div class="mb-6 text-dark-gray md:mb-8">
      <p class="mb-6">The onboarding packet has been completed.</p>
      <p v-if="companyTypeText == 'dispatcher'">
        You can add more carriers in your Dispatcher Portal.
      </p>
    </div>
    <button-main
      v-if="['carrier', 'broker'].includes(companyTypeText)"
      @click="$router.push('/carrier/brokers')"
    >
      Go to Carrier Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
    <button-main
      v-if="companyTypeText == 'dispatcher'"
      @click="$router.push('/dispatcher')"
    >
      Go to Dispatcher Portal
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
  </layout>
</template>

<script>
import Layout from '../layouts/HoldingTankLayout.vue';
import Button from '../Button.vue';

export default {
  name: 'Complete Holding Tank',
  components: {
    'button-main': Button,
    Layout,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: Array,
    incompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
  },
  computed: {
    companyTypeText() {
      return (
        this.$store.state.users.currentUser.company.company_type ||
        this.companyType
      );
    },
    brokerLogoUrl() {
      return this.$store.state.company?.company?.logo?.url || this.brokerLogo;
    },
  },
  async created() {
    if (!this.brokerLogo) {
      await this.$store.dispatch(
        'company/getCompanyByClientId',
        localStorage.getItem('client_id')
      );
    }
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
